export default __webpack_public_path__ + "static/media/Group 567.337bc74d.svg";